import { forwardRef, HTMLAttributes } from "react";
import cx from "classnames";

import { withTestId } from "utils/withTestId";

import { COUNTER_TEST_ID } from "./constants";
import styles from "./styles.module.css";

export type CounterProps = {
  count: number | string;
  variant?: "default" | "inversed" | "highlighted" | "danger" | "warning" | "subdued";
  size?: "minimized" | "small" | "medium";
} & Omit<HTMLAttributes<HTMLDivElement>, "children">;

const Counter = forwardRef(function Counter(
  { count, className, variant = "default", size = "medium", ...rest }: CounterProps,
  ref: React.ForwardedRef<HTMLDivElement>
) {
  return (
    <div
      ref={ref}
      className={cx(styles.counter, styles[size], styles[variant], className)}
      {...withTestId(COUNTER_TEST_ID)}
      {...rest}
    >
      {size === "minimized" ? null : count}
    </div>
  );
});

Counter.displayName = "DS.Counter";

export default Counter;
